import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>``;

export const CloseIconIdMission = ({ className }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='19.3 19.3 25.499999999999996 25.499999999999996'
        enable-background='new 0 0 64 64'
        width='16'
        height='16'
    >
        <g id='close-outline-bot_x5F_s1g1_x5F_s2g2_x5F_s3g1_x5F_s4g1'>
            <line
                fill='none'
                stroke='#000000'
                strokeWidth='1'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeMiterlimit='10'
                x1='19.75'
                y1='44.25'
                x2='44.25'
                y2='19.75'
            ></line>
        </g>
        <g id='close-outline-top_x5F_s1g1_x5F_s2g2_x5F_s3g1_x5F_s4g1'>
            <line
                fill='none'
                stroke='#000000'
                strokeWidth='1'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeMiterlimit='10'
                x1='44.25'
                y1='44.25'
                x2='19.75'
                y2='19.75'
            ></line>
        </g>
    </SvgElement>
);
